import Dashboard from '../containers/dashboard'
import PaymentWithAlertsDetailsManagement from '../containers/payment-with-alerts-details-management'

const PaymentWithAlertsDetails = () => {
  return (
    <Dashboard>
      <PaymentWithAlertsDetailsManagement />
    </Dashboard>
  )
}

export default PaymentWithAlertsDetails
